import React from 'react';

import HandyPageWrapper from '~Scenes/Handy/Components/HandyPageWrapper';
import BlueprintsSettings from '~Scenes/Settings-v2/Scenes/Blueprints';
import { useI18n } from '~Hooks';

/** Handheld shell around the shared Settings-v2 blueprints scene */
const Page = () => {
  const { i18n } = useI18n();

  return (
    <HandyPageWrapper pageTitle={i18n('Settings.Blueprints')}>
      <BlueprintsSettings isHandy />
    </HandyPageWrapper>
  );
};

export default Page;
